/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PromptSuggestionList } from '../../models/prompt-suggestion-list';
import { SuggestionsCreationData } from '../../models/suggestions-creation-data';

export interface ConversationGetPromptSuggestionList$Params {
  conversationId: string;
      body: SuggestionsCreationData
}

export function conversationGetPromptSuggestionList(http: HttpClient, rootUrl: string, params: ConversationGetPromptSuggestionList$Params, context?: HttpContext): Observable<StrictHttpResponse<PromptSuggestionList>> {
  const rb = new RequestBuilder(rootUrl, conversationGetPromptSuggestionList.PATH, 'post');
  if (params) {
    rb.path('conversationId', params.conversationId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PromptSuggestionList>;
    })
  );
}

conversationGetPromptSuggestionList.PATH = '/conversation/{conversationId}/suggestion/list';
